import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import MinimalLayout from '../../layouts/MinimalLayout'

// Explicitly import the component file to avoid any potential issues with
// directory index resolution in dynamic imports.
const OnboardingPage = lazy(
  () => import('../../pages/OnboardingPage/OnboardingPage'),
)

export const getOnboardingRoutes = () => [
  {
    element: <MinimalLayout />,
    children: [{ path: 'onboarding', element: <OnboardingPage /> }],
  },
  { path: '*', element: <Navigate to="/onboarding" replace /> },
]
